import { makeStyles } from '@material-ui/core/styles'
const useStyles = makeStyles(() => ({
  svgDimensions: {
    width: '20%',
    '@media (max-width: 500px)': {
      width: '30%',
      height: '140%',
    },
  },
}))

export { useStyles }
